module.exports = __webpack_public_path__ + "img/niutech_vit.37c21493.svg";